module.exports = __webpack_public_path__ + "dist/assets/img/numeric.d4439235.svg";